// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__3jnc7","buttonLarge":"Button_buttonLarge__GspYo","icon":"Button_icon__eLV3Y"};